import env from "@/environment";
import { AbstractUser, UserManager } from "@north-beam/nb-client-side/user";

export class User extends AbstractUser {}

export const userManager = new UserManager(
  {
    apiRoot: env.apiRoot,
    heavyApiRoot: env.heavyApiRoot,
    cpuIntensiveApiRoot: env.cpuIntensiveApiRoot,
    jobManagerApiRoot: env.jobManagerApiRoot,
  },
  User,
);
